import classNames from 'classnames';
import type { CSSProperties, ReactNode } from 'react';
import { FormattedMessage, FormattedNumber } from 'react-intl';
import styled from 'styled-components';

import { CollectionArrow } from '#src/atoms/icons/CollectionArrow.tsx';
import { Vertical } from '#src/atoms/layout/flex/index.tsx';
import { LabelM, LabelS } from '#src/atoms/typography/index.tsx';

const Root = styled(Vertical).attrs({ center: true })`
  color: var(--c-nd-600);

  &.row {
    flex-direction: row;
  }

  &.green {
    --text-color: var(--c-green-200);
    --text-shadow-color: var(--c-green-400);
  }

  &.shiny {
    color: var(--text-color, var(--c-yellow-200));
    text-shadow: 0px 1px 7px var(--text-shadow-color, var(--c-yellow-400));
  }

  &.faded {
    opacity: 0.5;
  }
`;
const Icon = styled.img`
  width: var(--double-unit);
  height: var(--double-unit);
  object-fit: contain;
`;

type Props = {
  shiny?: boolean;
  color?: 'green';
  faded?: boolean;
  bonus?: Nullable<number>;
  badge?: { pictureUrl?: Nullable<string>; name?: string };
  icon?: ReactNode;
  row?: boolean;
};
export const ThresholdLabel = ({
  shiny,
  color,
  faded,
  bonus,
  badge,
  icon,
  row,
}: Props) => {
  return (
    <Root
      center
      gap={0.5}
      className={classNames(color, {
        shiny,
        faded,
        row,
        'text-gradient-color': color === 'green',
      })}
      style={
        {
          '--text-gradient-color':
            color === 'green'
              ? 'linear-gradient(323deg, #F1FF00, #3DDC84)'
              : undefined,
        } as CSSProperties
      }
      {...(shiny && !faded ? { role: 'status' } : {})}
    >
      {typeof bonus === 'number' && (
        <>
          {icon || <CollectionArrow shiny={shiny} />}
          <span>
            <LabelM bold as="span">
              <FormattedNumber
                value={bonus * 100}
                maximumFractionDigits={2}
                signDisplay="always"
              />
            </LabelM>
            <LabelS as="span">%</LabelS>
          </span>
        </>
      )}
      {!!badge?.pictureUrl && (
        <>
          <Icon src={badge.pictureUrl} alt={badge.name} />
          <LabelM bold as="span">
            <FormattedMessage defaultMessage="Badge" />
          </LabelM>
        </>
      )}
    </Root>
  );
};
